export type FormValue = number | string | boolean;
export interface FormData {
  [controlName: string]: FormValue[] | FormValue | FormData | FormData[];
}
